import React from 'react';
import Header from '../../components/Header';


export default function Dashboard(props) {
  return (
    <>
      <Header />
      {props.children}
    </>
  )
}
